module.exports = __webpack_public_path__ + "static/media/素炸蚵仔便當.2ea63052.jpg";